import { defineStore } from 'pinia'

type State = {
  options: object,
  enabled: boolean,
}

export const useContentPreloaderStore = defineStore('contentPreloader', {
  state: (): State => ({
    options: {},
    enabled: false,
  }),

  actions: {
    updateStatus(payload: boolean) {
      this.enabled = payload
    },
    setOptions(options: object) {
      this.options = options
    }
  }
})
